<template>
  <div
    v-if="initiatedThirdParty && $slots.default"
    class="thirdparty"
    :class="{ 'thirdparty--initiated': initiatedThirdParty }"
  >
    <slot />
  </div>
  <div v-else />
</template>

<script setup lang="ts">
// Based on: https://constantsolutions.dk/2020/06/delay-loading-of-google-analytics-google-tag-manager-script-for-better-pagespeed-score-and-initial-load/

let timer: number | undefined

const { query } = useRoute()
const { initiatedThirdParty } = useApp()

const props = withDefaults(defineProps<{
  loadtime: number
}>(), {
  loadtime: 0,
})

const init = () => {
  if (!initiatedThirdParty.value) {
    if (query?.thirdparty !== 'disabled') {
      initiatedThirdParty.value = true
    }
    removeListeners()
  }
}

function initTimer() {
  document.addEventListener('scroll', init)
  timer = window.setTimeout(init, props.loadtime)
}

const addListeners = () => {
  initTimer()
  document.addEventListener('mousedown', init)
  document.addEventListener('mousemove', init)
  document.addEventListener('keydown', init)
}

const removeListeners = () => {
  window.clearTimeout(timer)
  document.removeEventListener('scroll', init)
  document.removeEventListener('mousedown', init)
  document.removeEventListener('mousemove', init)
  document.removeEventListener('keydown', init)
}

onMounted(() => {
  addListeners()
})

onBeforeUnmount(() => {
  removeListeners()
})
</script>
